module.exports = __webpack_public_path__ + "img/game-3.fa1a5913.png";